import React from 'react';
import c from 'classnames';

import type { WebformMapperProps } from '../Mapper';
import { IMap } from '../types';

export interface WebformContainerProps extends WebformMapperProps {
  WebformMapper: React.FC<WebformMapperProps>
}

const answerFieldTypes = new Set(['textfield', 'textarea']);

const WebformContainer: React.FC<WebformContainerProps> = ({
  entities,
  WebformMapper,
  ...props
}) => {
  const classNames = entities.getIn(['#attributes', 'class', 0]) as string;

  // Remove al non-element children.
  const children = entities.filter((_, k) => k.indexOf('#') !== 0);

  // Only continue if there are any question or answer children.
  if (!children.find((v: IMap) => answerFieldTypes.has(v.get('#type') as string))) {
    return null;
  }

  return (
    <div className={c('WebformContainer', classNames)}>
      <WebformMapper {...props} entities={children} />
    </div>
  );
};

export default WebformContainer;
